import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { PaymentTransactionViewModel } from "src/app/model/PaymentTransactionViewModel";
import { PaymentReconciliationService } from "src/app/services/payment-reconciliation.service";

@Component({
  selector: "app-secure-payment-pending-transactions",
  templateUrl: "./payment-pending-transactions.component.html",
  styleUrls: ["./payment-pending-transactions.component.scss"],
})
export class PaymentPendingTransactionsComponent implements OnInit {
  isLoading = false;
  lst: PaymentTransactionViewModel[];

  constructor(
    private router: Router,
    private paymentReconciliationService: PaymentReconciliationService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.paymentReconciliationService.fetchPendingTransactionList().subscribe((lst) => {
      this.isLoading = false;
        this.lst = lst.filter(o => 
          o.transactionId.startsWith('2806') || o.transactionId.startsWith('2906') || o.transactionId.startsWith('3006')
        || o.transactionId.startsWith('0107') 
        || o.transactionId.startsWith('0207') || o.transactionId.startsWith('0307')
        || o.transactionId.startsWith('0407') || o.transactionId.startsWith('0507')
        || o.transactionId.startsWith('0607'));

//         select a.key, op.response_message from application a, online_payment op
// where application_payment_status = 'PAYMENT_RECEIVED'
// and op.application_id = a.key and op.payment_status = 'SUCCESS'
// and emd_app_fee_payment_method is null;

// update application set emd_app_fee_payment_method = 'RTGS_NEFT' where 
// application_payment_status = 'PAYMENT_RECEIVED' and emd_app_fee_payment_method is null;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  async runJob() {
    if(this.lst && this.lst.length > 0) {
      await this.onCheckTransactionStatus(0);
    }
  }

  async onCheckTransactionStatus(i: number) {
    this.lst[i].loading = true;
    this.paymentReconciliationService.fetchPaymentReconciliationByTransactionId(this.lst[i].transactionId)
    .subscribe(async (data) => {
      let obj = this.lst.find(o => o.transactionId === this.lst[i].transactionId);
      obj.loading = false;
      obj.jobResponse = data.paymentStatus;
      if(i < this.lst.length) {
        this.onCheckTransactionStatus(++i);
      }
    }, error => {
      this.onCheckTransactionStatus(++i);
    });
  }
  
}